/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Terms_Of_Service_TitleInputs */

const en_nav_terms_of_service_title = /** @type {(inputs: Nav_Terms_Of_Service_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Service`)
};

const es_nav_terms_of_service_title = /** @type {(inputs: Nav_Terms_Of_Service_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Términos de servicio`)
};

/**
* | output |
* | --- |
* | "Terms of Service" |
*
* @param {Nav_Terms_Of_Service_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_terms_of_service_title = /** @type {((inputs?: Nav_Terms_Of_Service_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Terms_Of_Service_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_terms_of_service_title(inputs)
	return es_nav_terms_of_service_title(inputs)
});